import { render, staticRenderFns } from "./Migrate.vue?vue&type=template&id=7eadacba&"
import script from "./Migrate.vue?vue&type=script&lang=ts&"
export * from "./Migrate.vue?vue&type=script&lang=ts&"
import style0 from "./Migrate.vue?vue&type=style&index=0&id=7eadacba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports